<template>
  <div v-if="isLoaded" class="export_images_v2">
    <div v-if="exportImagesOptions" class="eiv2_body">
      <van-tabs
        v-if="isShowNavTabs"
        v-model="activeIndex"
        :ellipsis="false"
        swipeable
        animated
        sticky
      >
        <van-tab v-for="o in exportImagesOptions" :key="o.key">
          <div slot="title" v-html="o.html" />
          <Component
            :is="o.key"
            :ref="o.key"
            v-bind="interestTableRiskBind(o.key)"
            :scene="scene"
            :result-data="resultData"
            :vertical="o.key === 'verticalTable'"
            :liability-show-type="_liabilityShowType"
            :is-show-business-card="isShowBusinessCard"
            :card-image-data="allCardImageData[o.key] || allCardImageData.common"
            :theme-settings="themeSettings"
            @previewAllImages="previewAllImages"
          />
        </van-tab>
      </van-tabs>

      <div v-if="!isShowNavTabs && exportImagesOptions.length === 1">
        <Component
          :is="o.key"
          v-for="o in exportImagesOptions"
          :key="o.key"
          :ref="o.key"
          v-bind="interestTableRiskBind(o.key)"
          :scene="scene"
          :result-data="resultData"
          :vertical="o.key === 'verticalTable'"
          :liability-show-type="_liabilityShowType"
          :is-show-business-card="isShowBusinessCard"
          :card-image-data="allCardImageData[o.key] || allCardImageData.common"
          :theme-settings="themeSettings"
          @previewAllImages="previewAllImages"
        />
      </div>
    </div>
    <div v-if="isShowActionButtons" class="footer">
      <div v-if="!['WECHAT_GAOKE', 'H5_BXZ'].includes(APP_CHANNEL) && currentImage.key !== 'longPic'" class="qrcode">
        <van-checkbox v-model="isShowBusinessCard">
          图片包含{{ ['H5_BXZ'].includes(APP_CHANNEL) ? '' : '名片和' }}二维码，客户可扫码进入计划书
        </van-checkbox>
      </div>
      <div class="actions">
        <div
          v-if="currentImage.key === 'longPic'"
          class="eis_preivew"
          @click="captureWebContent"
        >
          <span>预览</span>
        </div>
        <ShareActions
          v-else
          :current-image="currentImage"
          @handle="onClickShareAction"
        />
      </div>
      <div v-if="isShowCancelButton" class="cancal" @click="$emit('cancel')">
        取消
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, Notify } from 'vant'
import QS from 'qs'
import { get as _get, cloneDeep } from 'lodash'
import { shareDirect } from '@/common/bridge';
import * as BC  from 'base/config'
import { APP_CHANNEL, BXS_APPID, URL_PARAM } from 'common/utils/variables'
import { getImagesOptions } from './constant'
import { drawCardImage, showImageViewer } from './handler'
import interestTable from './components/interest_table/index.vue'
import horizontalTable from './components/normal_table/index.vue'
import verticalTable from './components/normal_table/index.vue'
import mindMapping from './components/mind_mapping/index.vue'
import indentTree from './components/indent_tree_g6/index.vue'
import normalTree from './components/normal_tree_g6/index.vue'
import longPic from './components/long_pic/index.vue'
import ShareActions from './components/actions/index.vue'

const { chartName } = URL_PARAM
export default {
  components: {
    interestTable,
    horizontalTable,
    verticalTable,
    mindMapping,
    indentTree,
    normalTree,
    longPic,
    ShareActions
  },
  props: {
    scene: {
      type: Number,
      default () {
        // 1-通用计划书结果页（commonPkResult）
        // 2-通用家庭计划书结果页（familyPkResult）
        // 3-计划书结果页（弹层）
        // 4-家庭计划书结果页（弹层）
        // 5-计划书结果页（PC版）
        // 6-家庭计划书结果页（PC版）
        return 3
      }
    },
    liabilityShowType: {
      type: Number,
      default: 0
    },
    plainResultData: Object,
    themeSettings: {
      type: Object,
      default: () => ({})
    },
    isShowInterestTable: Boolean,
    exportRiskHasInterestDemo: {
      default: undefined,
      validator: v => v === undefined || typeof v === 'boolean'
    },
    exportRiskHasBonus: {
      default: undefined,
      validator: v => v === undefined || typeof v === 'boolean'
    }
  },
  data () {
    return {
      isLoaded: false,
      APP_CHANNEL,
      resultData: cloneDeep(this.plainResultData) || null,
      activeIndex: 0,
      allCardImageData: {},
      isShowBusinessCard: !['WECHAT_GAOKE', 'H5_BXZ'].includes(APP_CHANNEL),
      actionChannel: null
    }
  },
  computed: {
    themeKey () {
      return _get(this, 'themeSettings.previewTheme') || ''
    },
    _liabilityShowType () {
      return Number(URL_PARAM.liabilityShowType || this.liabilityShowType) || 0
    },
    isShowNavTabs () {
      return ![5, 6].includes(this.scene)
    },
    isShowActionButtons () {
      return this.currentImage && ![5, 6].includes(this.scene)
    },
    isShowCancelButton () {
      return [3, 4].includes(this.scene)
    },
    exportImagesOptions () {
      const { scene, isShowInterestTable, appPlatform } = this
      const options = getImagesOptions(scene, {
        isShowInterestTable
      })
      if ([5, 6].includes(scene)) {
        return options.filter(ele => ele.key === (chartName || 'horizontalTable'))
      }
      if (appPlatform === 'WECHAT_GAOKE') {
        return options.filter(o => !['longPic'].includes(o.key))
      }
      return options
    },
    currentImage () {
      const index = this.activeIndex < 0 ? 0 : this.activeIndex
      return this.exportImagesOptions[index]
    },
    imagesOptionsCanRenderByWeb () {
      return this.exportImagesOptions.filter(o => o.key !== 'longPic')
    },
    shareToPrintInfo () {
      const { scene, _liabilityShowType, resultData, currentImage, themeKey : theme } = this
      const { uuid, coverId, familyId } = URL_PARAM
      const name = _get(resultData, 'card.name') || ''
      const cardUuid = _get(resultData, 'card.uuid') || _get(resultData, 'card.userUuid') || ''
      const appId = _get(resultData, 'card.tobAppId') || ''
      let title = `${name}为您定制的保险计划书`
      let content = '专属保障计划请查阅！保险—让生活更美好'
      let imgUrl = _get(resultData, 'insuranceType.wechatSharedLogoUrl') || ''
      if ([2, 4].includes(scene)) {
        const firstMemberName = _get(resultData, 'members[0].name') || ''
        const firstMemberSex = _get(resultData, 'members[0].sex')
        const preTitle = firstMemberName ? `${firstMemberName}${firstMemberSex == 1 ? '先生' : '女士'}的` : ''
        title = `${preTitle}家庭保障计划`
        content = '请查收您的专属家庭保障计划，保险让生活更美好'
        imgUrl = 'https://img.winbaoxian.com/autoUpload/planbook/1561594277637_.pic_hd_7feb9fe70ec74de.jpg'
      }
      const urlParams = {
        chartName: _get(currentImage, 'key') || '',
        uuid,
        coverId,
        theme,
        familyId,
        cardUuid,
        appId,
        liabilityShowType: _liabilityShowType
      }

      if (BC.isBxs || BC.APPID == BXS_APPID) {
        urlParams.app = 'Bxs'
      } else if (BC.isBroker) {
        urlParams.app = 'Broker'
      } else if (BC.isToBApp || BC.isWeCom) {
        urlParams.app = Cookies.get('appId')
      } else if (BC.APPID) {
        urlParams.app = BC.APPID
      }

      return  {
        title,
        content,
        imgUrl,
        shareUrl: `${location.origin}${location.pathname}`.replace(/pages\/.*\.html/, 'pages/planbkChartInPcv2.html') + `?${QS.stringify(urlParams)}`,
        shareChannel: ['wechat_friends']
      }
    }
  },
  watch: {
    themeKey () {
      this.drawAllCardImages()
    }
  },
  async created () {
    await this.drawAllCardImages()
    this.isLoaded = !!this.resultData && !!this.currentImage
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    interestTableRiskBind (key) {
      if (key !== 'interestTable') return {}
      const o = {}
      if (typeof this.exportRiskHasInterestDemo === 'boolean') o.riskHasInterestDemo = this.exportRiskHasInterestDemo
      if (typeof this.exportRiskHasBonus === 'boolean') o.riskHasBonus = this.exportRiskHasBonus
      return o
    },
    async init () {
      this.activeIndex = Math.max(this.exportImagesOptions.findIndex(o => o.key === URL_PARAM.chartName), 0)
    },
    async drawAllImages () {
      const allImagesData = {}
      appBridge.showLoading()
      for (const option of this.imagesOptionsCanRenderByWeb) {
        const _currentImage = await this.getCurrentImage(option.key, false)
        if (_currentImage.dataUrl) {
          allImagesData[option.key] = _currentImage.dataUrl
        }
      }
      appBridge.hideLoading()
      return allImagesData
    },
    async drawAllCardImages () {
      const self = this
      const { scene, resultData, exportImagesOptions, themeKey : theme } = self
      const userInfo = _get(resultData, 'card') || {}
      const { uuid, coverId } = URL_PARAM
      const { uuid : cardUuid, photo, name, telephone, userUuid, tobAppId } = userInfo
      // 如果 photo 是 img.winbaoxian.com 域名的，替换成 media.winbaoxian.com  解决img.winbaoxian.com在ai-baoxiaozhu域名下绘制报错问题
      let photoUrl = photo
      if (typeof photo === 'string' && photo.includes('img.winbaoxian.com')) {
        photoUrl = photo.replace('img.winbaoxian.com', 'media.winbaoxian.com')
      }
      const cardInfo = {
        nw: 1,
        uuid,
        theme,
        coverId,
        cardUuid: cardUuid || userUuid,
        appId: tobAppId,
        photo: photoUrl,
        name,
        telephone
      }
      if (['H5_BXZ'].includes(APP_CHANNEL)) {
        cardInfo.photo = ''
        cardInfo.name = ''
        cardInfo.telephone = ''
      }
      const allCardImageData = {}
      allCardImageData.common = await drawCardImage(cardInfo, {
        scene
      }).catch(() => {})
      const mindMappingOption = exportImagesOptions.find(e => e.key === 'mindMapping')
      if (mindMappingOption) {
        allCardImageData.mindMapping = await drawCardImage(cardInfo, {
          scene,
          width: 375,
          fontSize: 12
        }).catch(() => {})
      }
      this.allCardImageData = allCardImageData
    },
    async onClickShareAction (key) {
      const self = this
      const _currentImageKey = _get(self, 'currentImage.key')
      const _ref = _get(self, `$refs[${_currentImageKey}][0]`)
      if (!_ref) {
        Toast(`加载失败：${_currentImageKey}`)
        return
      }
      switch (key) {
        case 'theme': {
          self.$emit('openThemePicker')
          break;
        }
        case 'setting': {
          self.$emit('openInterestSettingPopup')
          break;
        }
        default: {
          const _currentImage = await self.getCurrentImage(null, true)
          if (_currentImage.dataUrl) {
            self.shareImage(key, _currentImage.dataUrl)
          }
        }
      }
      window.WeiyiStatSDK.submit(key, {
        type: _currentImageKey
      })
    },
    async shareImage (shareChannel, imgData) {
      const { shareToPrintInfo, appPlatform } = this
      switch(shareChannel) {
        case 'wechat_timeline':
        case 'wechat_friends':
        case 'qq_friends': {
          if (appBridge.checkAppFeature('SHARE_POSTER_IMAGE')) {
            appBridge.sharePosterImage({
              imageType: 1,
              imgUrl: '',
              imageData: imgData,
              shareChannel: [shareChannel]
            })
          }
          break
        }
        case 'download': {
          if (['WXMP', 'WXMP_BXZ', 'WECHAT_GAOKE'].includes(appPlatform)) {
            showImageViewer(imgData)
            Notify({
              message: '长按保存图表',
              color: '#fff',
              background: '#0A64FE',
              duration: 6000
            })
            break
          }
          if (['H5_BXZ'].includes(appPlatform)) {
            const a = document.createElement('a')
            a.href = imgData
            a.download = `导出图片-${new Date().getTime()}.png`
            a.click()
            break
          }
          if (appBridge.checkAppFeature('SAVE_POSTER_IMAGE')) {
            appBridge.savePosterImage({
              type: 1,
              imgUrl: '',
              imageData: imgData
            })
          }
          break
        }
        case 'print': {
          if (BC.isNuoYa) {
            shareDirect(shareToPrintInfo)
          } else if (appBridge && appBridge.checkAppFeature('APP_SHARE')) {
            appBridge.share(shareToPrintInfo)
          }
          break
        }
        case 'nuoya_share': {
          shareDirect({
            type: 1,
            imageData: imgData,
          })
          break
        }
      }
    },
    captureWebContent () {
      if (!appBridge || !appBridge.checkAppFeature('CAPTURE_WEB_CONTENT')) {
        return
      }
      this.$emit('screen-capture', async () => {
        try {
          const res = await appBridge.captureWebContent()
          return Promise.resolve(res.status)
        } catch (err) {
          return Promise.reject(err)
        }
      })
      this.$emit('cancel')
    },
    async previewAllImages () {
      const self = this
      const { scene, activeIndex, currentImage, shareToPrintInfo, imagesOptionsCanRenderByWeb } = self
      const _currentImageKey = _get(currentImage, 'key')
      if ([5, 6].includes(scene)) {
        return
      }
      const hasPreviewImagesToShare = appBridge && appBridge.checkAppFeature('PREVIEW_IMAGES_TO_SHARE')
      if (hasPreviewImagesToShare) {
        const allImagesData = await self.drawAllImages()
        const imageInfos = imagesOptionsCanRenderByWeb
          .filter(item => allImagesData[item.key])
          .map(item => ({
            imageData: allImagesData[item.key],
            shareItemInfo: item.key === 'interestTable' ? null : shareToPrintInfo
          }))
        if (imageInfos.length) {
          const index = allImagesData[_currentImageKey] ? activeIndex : 0
          appBridge.previewImagesToShare(imageInfos, index)
        } else {
          Toast('没有生成图片')
        }
        console.log('PREVIEW_IMAGES_TO_SHARE')
      } else {
        const _currentImage = await self.getCurrentImage(null, true)
        if (_currentImage.dataUrl) {
          showImageViewer(_currentImage.dataUrl)
        } else {
          Toast('没有生成图片')
        }
        console.log('showImageViewer')
      }
    },
    async getCurrentImage (key, isShowLoading = true) {
      const _currentImage = key ? {
        key
      } : cloneDeep(this.currentImage) || {}
      const _key = _get(_currentImage, 'key')
      const _generateImage = _get(this, `$refs[${_key}][0].generateImage`)
      let dataUrl = null
      if (_generateImage) {
        dataUrl = await _generateImage(isShowLoading)
      }
      _currentImage.dataUrl = dataUrl
      return _currentImage
    }
  }
}
</script>
<style>
  @import './index.css';
</style>
